<template>
  <div class="container--login">
    <Head title="Update Email Page" />
    <div id="login" v-if="step">
      <img src="/img/04_Subit_logo_B.png" alt="logo_menu" class="logo" style="width: 280px" />
    </div>
  </div>
</template>
<style lang="css">
* {
  padding: 0;
  margin: 0;
}

.close_btn {
  float: right;
  margin: 10px;
  width: 70px;
}

.error_box {
  position: fixed;
  z-index: 10;
  width: 100%;
  height: 100%;
  background: rgba(1, 1, 1, 0.3);
}

.eb {
  border: solid black;
  background: #fffbf9;
  width: 350px;
  height: 160px;
  position: absolute;
  top: 5%;
  left: 50%;
  transform: translate(-50%);
}

.eb p {
  margin: 0;
  padding: 10px;
  font-size: small;
  font-weight: 300;
}

.error {
  background: #d20000;
  color: white;
}

.fp {
  text-align: center;
}

.fp a {
  opacity: 0.5;
  color: white;
}

.fp u {
  cursor: pointer;
  opacity: 0.5;
  color: #333;
}

input::placeholder {
  text-align: center;
}

#email,
#password {
  width: 280px;
}

#code {
  width: 280px;
}

#sb {
  width: 280px;
  margin: 15px 0;
  background: #183e7a;
  border-radius: 30px;
  color: white;
  font-weight: bold;
}

.active {
  display: block;
}

.lf_rm {
  position: relative;
}

.lf_submit {
  float: right;
}

.logo {
  display: block;
  margin: 0 auto;
}

.body {
  width: 100%;
  height: 100%;
  position: relative;
}

#login {
  position: absolute;
  color: white;
  top: 50%;
  left: 25%;
  transform: translate(-50%, -50%);
}

#login_box {
  padding: 12px 10px 10px 10px;
  width: 300px;
  height: 200px;
}
</style>

<script>
import { Head } from '@inertiajs/inertia-vue3';
import { Inertia } from '@inertiajs/inertia';

export default {
  data() {
    return {
      email: '',
      password: '',
      code: '',
      recovery_code: '',
      userId: -1,
      isActive: false,
      isActive2: false,
      isActive3: false,
      isActive4: false,
      width: window.innerWidth,
      height: window.innerHeight,
      step: true,
      step2: false,
    };
  },
  props: {
    message: String, // ユーザー名
  },
  mounted: function () {
    alert(this.message);
    Inertia.visit('/login');
  },
  beforeDestroy: function () {
    window.removeEventListener('resize', this.handleResize);
  },
};
</script>
